import { EMPTY } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { ContentProvider } from '@awp/content';
import { MenuService } from '@awp/app-common';
import * as i0 from "@angular/core";
import * as i1 from "../../../../app-common/src/lib/menu.service";
import * as i2 from "../../../../content/src/lib/content.provider";
var MenuContentResolver = /** @class */ (function () {
    function MenuContentResolver(menuService, contentProvider) {
        this.menuService = menuService;
        this.contentProvider = contentProvider;
    }
    MenuContentResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var menuId = route.paramMap.get('menuId');
        return this.menuService.values.pipe(map(function (items) {
            var page = items.find(function (i) { return i.url === menuId; });
            if (page == null) {
                console.warn("Page '" + menuId + "' not found");
            }
            return page;
        }), switchMap(function (menu) {
            return menu != null && menu.contentUrl != null
                ? _this.contentProvider.fetchContent(menu.contentUrl)
                : EMPTY;
        }), take(1));
    };
    MenuContentResolver.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MenuContentResolver_Factory() { return new MenuContentResolver(i0.ɵɵinject(i1.MENU_TOKEN), i0.ɵɵinject(i2.ContentProvider)); }, token: MenuContentResolver, providedIn: "root" });
    return MenuContentResolver;
}());
export { MenuContentResolver };
